import { createSlice } from "@reduxjs/toolkit";
import initialState from "view/account/store/initial-state";

const { actions, reducer } = createSlice({
  name: "account",
  initialState,
  reducers: {
    setCounterIncrement(state) {
      state.counter += 1;
    },
    setCounterDecrement(state) {
      state.counter -= 1;
    },
  },
});

export { actions };
export default reducer;
